'use strict';
import {module} from '../app';
import pubsubService from '../services/pubsub.service';
import { ChangePasswordDialogModel } from "../models/changePasswordDialogModel";
let config = require('../../../package.json');

const pingTimeout = 3000;
const techpadOptionPrefixKey = "TechpadOptions::";
module.controller('LoginCtrl', [
  '$rootScope', '$scope', 'authService', '$state', 'Magview', 'signalrService', 'modalService', '$ionicLoading', 'localStorage', 'WorklistUserSettings',
  'serverTimeService', 'techpadConfig', '$timeout', '$location', 'Config',
  function ($rootScope, $scope, authService, $state, Magview, signalrService, modalService, $ionicLoading, localStorage, WorklistUserSettings,
            serverTimeService, techpadConfig, $timeout, $location, Config) {
    let vm = {
      username: '',
      password: '',
      loading: false,
      isOffline: false,
      message: '',
      checkingHospitalCode: false,
      currentHospital: localStorage.getObject('hospital'),
      pingsNumber: 20,
      worklistUserSettings: WorklistUserSettings,

      changeTechnologistPassword: async function (params) {
        let model = new ChangePasswordDialogModel({ authService, portal: params.portal, username: params.username, password: params.password, authToken: params.authToken });
        await modalService.showChangePasswordWindow(model);
      },

      login: function () {
        if (!vm.currentHospital) {
          vm.message = 'Hospital is required';
          return;
        }

        vm.message = '';
        vm.loading = true;
        // authService.shouldCheckIfAlreadyLoggedIntoChat = false;
        authService.login(vm.username, vm.password, vm.currentHospital, vm.changeTechnologistPassword)
          .then(function () {

            const password = vm.password;
            vm.loading = false;
            vm.message = '';
            vm.password = '';

            techpadConfig.reload().then(function () {
              if (techpadConfig.settings && techpadConfig.settings.IsShowChatMenuItem) {
                pubsubService.off('CHAT_LOGIN_DONE');
                pubsubService.on('CHAT_LOGIN_DONE', () => {
                  // authService.shouldCheckIfAlreadyLoggedIntoChat = true;
                });
                pubsubService.off('CHAT_MODULE_MAKE_INITIAL_LOAD_DONE');
                pubsubService.on('CHAT_MODULE_MAKE_INITIAL_LOAD_DONE', () => {
                  pubsubService.dispatch('USER_LOGGED_IN', {
                    username: vm.username.toUpperCase(),
                    password: password
                  });
                });
              }
              vm.worklistUserSettings.getUsersSettings()
                .then(function (settings) {
                  localStorage.setObject(
                    techpadOptionPrefixKey + authService.getUserName(),
                    settings
                  );

                  if(settings && settings.DarkMode && !$("body").hasClass("dark-mode")) {
                    $("body").addClass("dark-mode");
                  } else if (!settings || (!settings.DarkMode && $("body").hasClass("dark-mode"))) {
                    $("body").removeClass("dark-mode");
                  }

                  if (!!$rootScope.redirectUrl) {
                    $location.url($rootScope.redirectUrl);
                  } else {
                    $state.go("root.worklist");
                  }
                })
                .catch(function (error) {
                  modalService.showErrorMessage(error.data, error.status);
                });
            });

            // timedMessageService.updateTimeouts();
            serverTimeService.updateServerTime();

          }, function (resp) {
            console.log('login resp', resp);
            if (resp && resp.status === 200) {
              if (typeof resp.data === 'string' || resp.data instanceof String) {
                vm.message = resp.data;
              } else {
                vm.message = 'Invalid username or password';
              }
            } else if(resp && resp.status === 404){
              modalService.showErrorMessage(`Wrong portal version, expected compatibility number: ${config.portalCompatibility}`);
            } else {
              modalService.showErrorMessage(resp.data, resp.status);
            }
            vm.loading = false;
          });
      },

      changeHospital: function () {
        modalService
          .showHospitalCodeInputWindow()
          .then(function (code) {
            if (!code) {
              return;
            }

            if (code.slice(0, 2) == '##') {

              let value = code.slice(2);

              if (value.slice(0, 4).toLowerCase() != "http") {
                value = "http://" + value;
              }

              let hospital = {
                name: 'Offline Mode',
                url: value,
                isOffline: true
              };

              vm.applyHospital(hospital);

            } else {
              
              //console.log('vm.localHospitalCodes', vm.localHospitalCodes);
              const selectedLocalHospitalCodeSetting = vm.localHospitalCodes && vm.localHospitalCodes.find(c => c.code.toLowerCase() === code.toLowerCase());

              if(selectedLocalHospitalCodeSetting){
                vm.applyHospital(selectedLocalHospitalCodeSetting);
                return;
              }

              if (!navigator.onLine) {
                modalService.showAlert('Internet is not available, please check your network settings.');
                return;
              }

              vm.hospitalNameWithStatus = '';
              vm.currentHospital = null;
              vm.checkingHospitalCode = true;


              $ionicLoading.show({
                template: 'Looking for specified code...'
              });

              Magview.getInstances()
                .then(function (response) 
                {
                  $ionicLoading.hide();
                
                  let hospital = response.data.instances.find((i) => (i.code || '').toLowerCase() == (code || '').toLowerCase());

                  if (hospital) {
                    vm.applyHospital(hospital);
                  } else {
                    vm.checkingHospitalCode = false;
                    modalService.showAlert('Specified hospital code is not found');
                  }
                })
                .catch(function (resp, status) {
                  $ionicLoading.hide();

                  if (status <= 1 || status == 404) {
                    let error = {message: "Techpad admin server is not reachable at the moment", details: resp};
                    modalService.showErrorMessage(error);
                  } else {
                    modalService.showErrorMessage(resp, status);
                  }
                });
            }
          });
      },

      checkServerAccess: function () {
        //vm.updateServerStatus();
        if (vm.currentHospital && Object.keys(vm.currentHospital).length != 0) {
          Magview.pingServer(vm.currentHospital.url).then(function (resp) {
            vm.updateServerStatus("online");
            vm.isOffline = false;

            // [JC]
            // trying to make sure if the server already warmed up
            // if yes, don't try to warm up the server again
            if (!vm.currentHospital.isWarmedUp) {
              vm.currentHospital.isWarmedUp = true;
              Magview.warmupPortal(vm.currentHospital.url);
              Magview.warmupMagviewApi(vm.currentHospital.url);
            }

            $timeout(function () {
              vm.checkServerAccess();
            }, pingTimeout);
          }, function (resp) {
            //modalService.showErrorMessage({ errorId: vm.currentHospital.code, message: "Server is not reachable at the moment" });
            $scope.safeApply(function () {
              vm.isOffline = true;
              $timeout(function () {
                vm.checkServerAccess();
              }, pingTimeout);
              vm.updateServerStatus("offline");
            });
          });
        }
      },

      updateServerStatus: function (status) {
        vm.status = status;
        vm.hospitalNameWithStatus = vm.currentHospital.name;
        if (vm.status) {
          vm.hospitalNameWithStatus += " (" + (vm.currentHospital.isLocal ? 'local' : 'web')/*vm.status*/ + ")";
          vm.checkingHospitalCode = false;
        }
      },

      applyHospital: function (hospital) {
        $scope.vm.settings = null;
        if (hospital.url.substr(-1) !== '/') {
          hospital.url += '/';
        }
        vm.currentHospital = hospital;
        localStorage.setObject('hospital', hospital);
        vm.checkServerAccess();
        vm.loadSettings();
      },

      async pingServer () {
        $ionicLoading.show({
          template: 'Pinging server...'
        });

        const result = await pingSvc.pingTest(vm.currentHospital.url, vm.pingsNumber);

        console.log(result);

        $ionicLoading.hide();

        modalService.showAlert(result.message);
      },

      loadSettings: function () {
        techpadConfig.reloadByMagViewUrl(vm.currentHospital.url).then(function () {
          if (Object.keys(techpadConfig.settings).length) {
            $scope.vm.settings = techpadConfig.settings;
          }
        });
      },
    };

    vm.checkServerAccess();
    vm.updateServerStatus();
    vm.loadSettings();

    Config.getConfig().then((config) => {
      vm.localHospitalCodes = config.data && config.data.hospitalCodes;
    });

    $scope.vm = vm;
    if (authService.loggedIn) {
      $state.go('root.worklist');
      return;
    }

  }
]);



// WEBPACK FOOTER //
// ./src/scripts/controllers/login.js